import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
    useRef,
    useState,
} from 'react';

import {
    useClickOutside,
} from 'tools/hooks';

import {
    useIsMobile,
} from 'helpers/adaptive';

import {
    SimpleButton,
} from 'components/buttons';

import styles from './MultiToggleInput.module.scss';

import {
    ToggleInput,
} from '..';

const MultiToggleInput: FC<IProps> = (props) => {
    const [isOpen, setIsOpen] = useState(false);

    const isMobile = useIsMobile();

    const ref = useRef<HTMLDivElement>(null);

    const onToggleValue = (value: string) => {
        if (props.value.includes(value)) {
            props.onChangeValue((props.value.filter((activeValue) => activeValue !== value)));
        } else {
            props.onChangeValue([...props.value, value]);
        }
    };

    useClickOutside(ref, () => {
        setIsOpen(false);
    });

    return (
        <div
            ref={ref}
            className={classNames(styles.multiToggleInput, props.className)}
        >
            <SimpleButton onClick={() => setIsOpen(!isOpen)}>
                {props.label}
            </SimpleButton>
            {
                isOpen &&
                <div className={styles.options}>
                    {
                        props.values
                            .map(
                                (valueItem) =>
                                    <div
                                        key={valueItem}
                                        className={styles.option}
                                    >
                                        <ToggleInput
                                            value={props.value.includes(valueItem)}
                                            onChangeValue={() => onToggleValue(valueItem)}
                                        />
                                        <div>
                                            {props.formatOption?.(valueItem, isMobile) ?? valueItem}
                                        </div>
                                    </div>
                            )
                    }
                </div>
            }
        </div>
    );
};

export default MultiToggleInput;
